import {_sharedActionsConstantsShare} from "./actions";

export const _sharedStateShare = {
  shareData: null,
};

export const _sharedReducerShare = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsShare.SET_SHARE_DATA: {
      return { ...state, shareData: action.data };
    }
    default:
      return state;
  }
};
